import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { useRadioGroup } from './RadioGroupContext';

function RadioButton({ value: itemValue, label }) {
  const { value, onChange, name } = useRadioGroup();

  const checked = itemValue === value;

  return (
    <label
      aria-label={itemValue}
      className={cx('dnd-radio-button__label', { active: checked })}>
      {label}
      <input
        className="dnd-radio-button__input"
        name={name}
        type="radio"
        value={itemValue}
        checked={checked}
        onChange={onChange}
      />
    </label>
  );
}

RadioButton.propTypes = {
  value: PropTypes.string.isRequired,
  label: PropTypes.node.isRequired,
};

export default RadioButton;
